// Story IG 9:16 (1080×1920) "Rangkuman Perkembangan Jawsel" — gaya kartu kesehatan modern (referensi user):
// latar krem Jawsel berblob biru/lavender, kartu KACA BURAM (glassmorphism: blur latar + putih tembus + tepi putih), toggle pil, KPI besar, batang pil membulat (yang belum terjadi = garis putus),
// garis tren dengan titik menyala + label nilai, dan bar horizontal kota teramai. Aksen tetap Jawsel Blue.
import { REGION_GEO } from "./jawselRegions";

const FONT = "'Plus Jakarta Sans', sans-serif", TEBAL = "'Outfit', 'Plus Jakarta Sans', sans-serif";
const BIRU = "#0000CD", BIRU_MUDA = "rgba(0,0,205,.16)", TINTA = "#1d1d1f", SUB = "rgba(29,29,31,.58)", LATAR = "#efe9d8", GARIS = "rgba(29,29,31,.08)", HIJAU = "#189a5b", MERAH = "#dc2626";
let LATAR_KANVAS = null;   // kanvas latar (blob) — sumber blur untuk kartu kaca
const f = (w, px) => `${w} ${px}px ${FONT}`, g = (w, px) => `${w} ${px}px ${TEBAL}`;
const W = 1080, H = 1920, M = 60;   // margin kiri/kanan

export async function siapkanFontStory() {
  if (!document.fonts) return;
  await Promise.all([f(800, 20), f(700, 20), f(600, 20), f(500, 20), g(900, 20), g(800, 20)].map(ft => document.fonts.load(ft).catch(() => {})));
}
function teks(ctx, t, x, y, font, warna, align = "left", spasi = 0) {
  ctx.save(); ctx.font = font; ctx.fillStyle = warna; ctx.textAlign = align; ctx.textBaseline = "alphabetic";
  if ("letterSpacing" in ctx) ctx.letterSpacing = `${spasi}px`;
  ctx.fillText(t, x, y); ctx.restore();
}
function lebar(ctx, t, font) { ctx.font = font; return ctx.measureText(t).width; }
function kotak(ctx, x, y, w, h, r, isi) { ctx.fillStyle = isi; ctx.beginPath(); ctx.roundRect(x, y, w, h, r); ctx.fill(); }
// Kartu kaca buram: bayangan lembut → latar di balik kartu diburamkan (ctx.filter blur) → lapisan putih tembus → tepi putih tipis + sorotan atas
function kartu(ctx, x, y, w, h, r = 40, putih = 0.5) {
  ctx.save(); ctx.shadowColor = "rgba(20,20,40,.12)"; ctx.shadowBlur = 44; ctx.shadowOffsetY = 16; kotak(ctx, x, y, w, h, r, "rgba(255,255,255,.01)"); ctx.restore();
  ctx.save(); ctx.beginPath(); ctx.roundRect(x, y, w, h, r); ctx.clip();
  if (LATAR_KANVAS) { ctx.filter = "blur(28px) saturate(1.5)"; ctx.drawImage(LATAR_KANVAS, -40, -40, W + 80, H + 80); ctx.filter = "none"; }
  ctx.fillStyle = `rgba(255,255,255,${putih})`; ctx.fillRect(x, y, w, h);
  const kilau = ctx.createLinearGradient(x, y, x + w, y + h); kilau.addColorStop(0, "rgba(255,255,255,.35)"); kilau.addColorStop(0.5, "rgba(255,255,255,0)"); kilau.addColorStop(1, "rgba(255,255,255,.18)");
  ctx.fillStyle = kilau; ctx.fillRect(x, y, w, h); ctx.restore();
  ctx.save(); ctx.strokeStyle = "rgba(255,255,255,.75)"; ctx.lineWidth = 2; ctx.beginPath(); ctx.roundRect(x + 1, y + 1, w - 2, h - 2, r - 1); ctx.stroke();
  ctx.strokeStyle = "rgba(255,255,255,.9)"; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.moveTo(x + r, y + 1.5); ctx.lineTo(x + w - r, y + 1.5); ctx.stroke(); ctx.restore();
}
// Latar: krem Jawsel + blob biru / lavender / mint lembut (digambar sekali, dipakai sebagai sumber blur kartu kaca)
function gambarLatar() {
  const c = document.createElement("canvas"); c.width = W; c.height = H; const g2 = c.getContext("2d");
  g2.fillStyle = LATAR; g2.fillRect(0, 0, W, H);
  const blob = (x, y, r, warna) => { const gr = g2.createRadialGradient(x, y, 0, x, y, r); gr.addColorStop(0, warna); gr.addColorStop(1, "rgba(255,255,255,0)"); g2.fillStyle = gr; g2.beginPath(); g2.arc(x, y, r, 0, Math.PI * 2); g2.fill(); };
  blob(160, 260, 520, "rgba(0,0,205,.38)"); blob(960, 620, 560, "rgba(159,159,255,.55)"); blob(260, 1250, 620, "rgba(45,212,191,.35)"); blob(900, 1500, 520, "rgba(0,0,205,.30)"); blob(560, 1900, 500, "rgba(236,72,153,.22)");
  // pola titik halus
  g2.fillStyle = "rgba(29,29,31,.05)"; for (let yy = 40; yy < H; yy += 44) for (let xx = 30 + (yy / 44 % 2) * 22; xx < W; xx += 44) { g2.beginPath(); g2.arc(xx, yy, 1.8, 0, Math.PI * 2); g2.fill(); }
  return c;
}
const tglID = (iso, opsi) => new Date(iso + "T00:00:00").toLocaleDateString("id-ID", opsi || { day: "numeric", month: "short" });
const persen = r => (r.sebelum ? Math.round(((r.kini - r.sebelum) / r.sebelum) * 100) : r.kini ? 100 : 0);

function stempel(ctx, x, y, t, skala = 1) {
  ctx.save(); ctx.translate(x, y); ctx.rotate(-0.09); ctx.scale(skala, skala);
  const w = lebar(ctx, t, g(900, 34)) + 36;
  ctx.strokeStyle = BIRU; ctx.lineWidth = 4; ctx.beginPath(); ctx.roundRect(-w / 2, -27, w, 54, 10); ctx.stroke();
  ctx.lineWidth = 1.6; ctx.beginPath(); ctx.roundRect(-w / 2 + 7, -20, w - 14, 40, 7); ctx.stroke();
  teks(ctx, t, 0, 12, g(900, 34), BIRU, "center", 4); ctx.restore();
}

// Toggle pil ala "4 weeks | 3 months": segmen aktif putih di atas pil abu
function togglePil(ctx, x, y, w, h, pilihan, aktif) {
  kartu(ctx, x, y, w, h, h / 2, 0.28);
  const sw = (w - 8) / pilihan.length;
  pilihan.forEach((p, i) => {
    const sx = x + 4 + i * sw;
    if (i === aktif) { ctx.save(); ctx.shadowColor = "rgba(0,0,0,.08)"; ctx.shadowBlur = 10; ctx.shadowOffsetY = 3; kotak(ctx, sx, y + 4, sw, h - 8, (h - 8) / 2, "rgba(255,255,255,.92)"); ctx.restore(); }
    teks(ctx, p, sx + sw / 2, y + h / 2 + 10, f(i === aktif ? 800 : 600, 28), i === aktif ? TINTA : SUB, "center");
  });
}

function kpi(ctx, x, y, w, h, label, r, aksen, banding, awalan = "") {
  kartu(ctx, x, y, w, h, 32);
  teks(ctx, label, x + 28, y + 54, f(600, 27), SUB);
  teks(ctx, `${awalan}${r.kini}`, x + 28, y + 146, g(900, 84), aksen, "left", -3);
  const p = persen(r), naik = p >= 0;
  kotak(ctx, x + 28, y + 172, 12, 12, 4, naik ? HIJAU : MERAH);
  teks(ctx, `${naik ? "+" : "−"}${Math.abs(p)}% ${banding}`, x + 50, y + 184, f(600, 22), SUB);
}

// Batang pil membulat: ember yang sudah terjadi = isi (puncak = biru pekat), belum terjadi = garis putus
function kartuBatang(ctx, rows, x, y, w, h, judul, sub, perJam, jamKini) {
  kartu(ctx, x, y, w, h);
  teks(ctx, judul, x + 36, y + 62, f(600, 30), SUB);
  teks(ctx, sub, x + w - 36, y + 62, f(500, 24), SUB, "right");
  const P = { l: 36, r: 36, t: 150, b: 80 }, iw = w - P.l - P.r, ih = h - P.t - P.b, n = rows.length, slot = iw / n;
  const lewat = i => !perJam || i <= jamKini;
  const maks = Math.max(1, ...rows.map(r => r.pengunjung)), puncak = rows.reduce((b, r, i) => (lewat(i) && r.pengunjung > (rows[b]?.pengunjung ?? -1) ? i : b), -1);
  const bw = Math.min(56, Math.max(10, slot * 0.6)), dasar = y + P.t + ih;
  rows.forEach((r, i) => {
    const cx = x + P.l + slot * (i + 0.5), th = Math.max(bw, (r.pengunjung / maks) * ih);
    if (!lewat(i)) { ctx.save(); ctx.setLineDash([6, 6]); ctx.strokeStyle = "rgba(29,29,31,.22)"; ctx.lineWidth = 2; ctx.beginPath(); ctx.roundRect(cx - bw / 2, dasar - ih * 0.45, bw, ih * 0.45, bw / 2); ctx.stroke(); ctx.restore(); return; }
    kotak(ctx, cx - bw / 2, dasar - th, bw, th, bw / 2, i === puncak ? BIRU : r.pengunjung ? BIRU_MUDA : "rgba(29,29,31,.07)");
    if (i === puncak && r.pengunjung) {   // label nilai di atas puncak
      const t = `+${r.pengunjung}`, tw = lebar(ctx, t, f(800, 26)) + 30;
      kotak(ctx, cx - tw / 2, dasar - th - 56, tw, 42, 21, TINTA); teks(ctx, t, cx, dasar - th - 26, f(800, 26), "#fff", "center");
    }
  });
  const langkah = Math.max(1, Math.ceil((perJam ? 70 : 118) / slot));
  rows.forEach((r, i) => { if (i % langkah === 0) teks(ctx, perJam ? r.label.slice(0, 2) : tglID(r.tanggal), x + P.l + slot * (i + 0.5), y + h - 32, f(500, 23), lewat(i) ? SUB : "rgba(29,29,31,.28)", "center"); });
}

// Garis tren total warga: sumbu Y kiri, garis biru, pendar lembut di ujung, garis putus vertikal + label nilai terakhir
function kartuTren(ctx, rows, x, y, w, h, judul, deltaTeks, perJam, jamKini) {
  kartu(ctx, x, y, w, h);
  const akhir = perJam ? Math.min(jamKini, rows.length - 1) : rows.length - 1, data = rows.slice(0, akhir + 1);
  teks(ctx, judul, x + 36, y + 62, f(600, 30), SUB);
  teks(ctx, deltaTeks, x + w - 36, y + 62, f(500, 24), SUB, "right");
  teks(ctx, String(data[data.length - 1].warga_total), x + 36, y + 136, g(900, 76), TINTA, "left", -3);
  teks(ctx, "warga", x + 36 + lebar(ctx, String(data[data.length - 1].warga_total), g(900, 76)) + 14, y + 136, f(600, 30), SUB);
  const P = { l: 96, r: 48, t: 186, b: 76 }, iw = w - P.l - P.r, ih = h - P.t - P.b;
  const vals = data.map(r => r.warga_total), lo = Math.max(0, Math.min(...vals) - 1), hi = Math.max(...vals) + 1;
  const X = i => x + P.l + (rows.length > 1 ? (iw * i) / (rows.length - 1) : 0), Y = v => y + P.t + ih - ((v - lo) / (hi - lo)) * ih;
  const nTick = Math.min(3, hi - lo);
  for (let k = 0; k <= nTick; k++) { const v = Math.round(lo + ((hi - lo) * k) / nTick), yy = Y(v); ctx.strokeStyle = GARIS; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(x + P.l, yy); ctx.lineTo(x + w - P.r, yy); ctx.stroke(); teks(ctx, String(Math.round(v)), x + P.l - 22, yy + 8, f(500, 23), SUB, "right"); }
  // pendar di ujung garis
  const ex = X(data.length - 1), ey = Y(vals[vals.length - 1]);
  const pendar = ctx.createRadialGradient(ex, ey, 0, ex, ey, 110); pendar.addColorStop(0, "rgba(0,0,205,.22)"); pendar.addColorStop(1, "rgba(0,0,205,0)");
  ctx.save(); ctx.beginPath(); ctx.roundRect(x, y, w, h, 40); ctx.clip(); ctx.fillStyle = pendar; ctx.beginPath(); ctx.arc(ex, ey, 110, 0, Math.PI * 2); ctx.fill(); ctx.restore();
  ctx.strokeStyle = BIRU; ctx.lineWidth = 5; ctx.lineJoin = "round"; ctx.lineCap = "round"; ctx.beginPath();
  data.forEach((r, i) => (i ? ctx.lineTo(X(i), Y(r.warga_total)) : ctx.moveTo(X(i), Y(r.warga_total)))); ctx.stroke();
  ctx.save(); ctx.setLineDash([6, 8]); ctx.strokeStyle = "rgba(29,29,31,.3)"; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(ex, y + P.t - 10); ctx.lineTo(ex, y + P.t + ih); ctx.stroke(); ctx.restore();
  ctx.fillStyle = "#fff"; ctx.strokeStyle = BIRU; ctx.lineWidth = 5; ctx.beginPath(); ctx.arc(ex, ey, 9, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
  const lbl = `${vals[vals.length - 1]} warga`, lw = lebar(ctx, lbl, f(800, 25)) + 32, lx = Math.min(ex + 20, x + w - P.r - lw);
  kotak(ctx, lx, ey - 56, lw, 42, 21, TINTA); teks(ctx, lbl, lx + lw / 2, ey - 27, f(800, 25), "#fff", "center");
  const langkah = Math.max(1, Math.ceil(rows.length / 6));
  rows.forEach((r, i) => { if (i % langkah === 0) teks(ctx, perJam ? r.label : tglID(r.tanggal), X(i), y + h - 32, f(500, 23), SUB, "center"); });
}

// Kota teramai: bar horizontal pil (ala "Fat loss −0.40") dengan warna wilayah dan nilai di kanan
function kartuKota(ctx, cities, x, y, w, h) {
  kartu(ctx, x, y, w, h);
  teks(ctx, "Kota teramai", x + 36, y + 62, f(800, 34), TINTA, "left", -0.8);
  const total = cities.reduce((s, c) => s + c.warga, 0);
  teks(ctx, `${total} warga asli · ${cities.length} kota`, x + 36, y + 96, f(500, 24), SUB);
  const top = [...cities].sort((a, b) => (b.warga - a.warga) || (b.buildings - a.buildings)).slice(0, 4), maks = Math.max(1, ...top.map(c => c.warga));
  const bx = x + 330, bw = w - 330 - 36 - 200;
  top.forEach((c, i) => {
    const yy = y + 152 + i * 57;
    teks(ctx, c.city_name, x + 36, yy + 9, f(600, 27), TINTA);
    kotak(ctx, bx, yy - 8, bw, 28, 14, "rgba(29,29,31,.07)");
    if (c.warga) kotak(ctx, bx, yy - 8, Math.max(28, (c.warga / maks) * bw), 28, 14, REGION_GEO[c.city_id]?.color || BIRU);
    teks(ctx, `${c.warga} warga · ${total ? Math.round((c.warga / total) * 100) : 0}%`, x + w - 36, yy + 9, f(800, 25), TINTA, "right");
  });
}

export function renderStoryPerkembangan({ hari, ringkasan, cities, jumlahHari, mode, jamKini }) {
  const perJam = mode === "jam", c = document.createElement("canvas"); c.width = W; c.height = H; const ctx = c.getContext("2d");
  LATAR_KANVAS = gambarLatar(); ctx.drawImage(LATAR_KANVAS, 0, 0);
  const cw = W - 2 * M, akhir = hari[hari.length - 1]?.tanggal || new Date().toISOString().slice(0, 10), awal = hari[0]?.tanggal || akhir;

  // kepala: tanggal kecil + judul besar + stempel; kanan: pil periode
  teks(ctx, tglID(akhir, { weekday: "long", day: "numeric", month: "short" }), M, 110, f(500, 30), SUB);
  teks(ctx, "Perkembangan", M, 178, g(900, 66), TINTA, "left", -2.5);
  stempel(ctx, M + lebar(ctx, "Perkembangan", g(900, 66)) + 90, 160, "JAWSEL", 1);
  const periode = perJam ? `s.d. ${String(jamKini ?? 0).padStart(2, "0")}:59 WIB` : `${tglID(awal)} – ${tglID(akhir)}`, pw = lebar(ctx, periode, f(700, 24)) + 64;
  kartu(ctx, W - M - pw, 112, pw, 54, 27, 0.45); kotak(ctx, W - M - pw + 20, 133, 12, 12, 6, BIRU); teks(ctx, periode, W - M - pw + 44, 148, f(700, 24), TINTA);

  // toggle pil rentang
  const pilihan = ["Hari ini", "7 hari", "14 hari", "30 hari"], aktif = perJam ? 0 : Math.max(0, [1, 7, 14, 30].indexOf(jumlahHari));
  togglePil(ctx, M, 222, cw, 84, pilihan, aktif);

  // 3 KPI
  const banding = perJam ? "vs kemarin" : "vs sebelumnya", kw = (cw - 2 * 20) / 3;
  kpi(ctx, M, 338, kw, 212, "Pengunjung", ringkasan.pengunjung, BIRU, banding);
  kpi(ctx, M + kw + 20, 338, kw, 212, "Warga baru", ringkasan.warga_baru, TINTA, banding, "+");
  kpi(ctx, M + 2 * (kw + 20), 338, kw, 212, "Penerjun", ringkasan.penerjun, HIJAU, banding);

  // batang pengunjung
  kartuBatang(ctx, hari, M, 582, cw, 480, perJam ? "Pengunjung per jam" : "Pengunjung per hari", `${ringkasan.pengunjung.kini} pengunjung unik`, perJam, jamKini ?? 23);

  // tren total warga
  const tambah = ringkasan.warga_baru.kini;
  kartuTren(ctx, hari, M, 1092, cw, 392, "Total warga Jawsel", `${tambah >= 0 ? "+" : ""}${tambah} warga ${perJam ? "hari ini" : "periode ini"}`, perJam, jamKini ?? 23);

  // kota teramai
  kartuKota(ctx, cities, M, 1514, cw, 356);

  // kaki
  teks(ctx, "jawsel.fun", W / 2, H - 22, f(700, 24), SUB, "center", 1);
  return c;
}
